module.exports = __webpack_public_path__ + "static/img/etsy-photo.aeea40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/etsy-photo.png
// module id = dUom
// module chunks = 1